import React from "react";
import withStyles from "@mui/styles/withStyles";
import ANFormView from "../../../elements/Forms/ANFormView";
import {SectionBox} from "@answersnow/pkg-theme";
import styles from "../styles";

const Bio = (props) => {
  const { basicInfo, photoUrl } = props;

  return (
    <SectionBox title="Bio" description={"Account Biography"} columnDirection>
      <ANFormView
        data={{
          appBio: basicInfo?.bio || "",
          photoUrl: photoUrl || basicInfo?.image_url || "",
        }}
        config={[
          { label: "", dataKey: "photoUrl", cols: 12, type: "avatar" },
          {
            label: "Bio",
            dataKey: "appBio",
            cols: 12,
          },
        ]}
      ></ANFormView>
    </SectionBox>
  );
};

export default withStyles(styles)(Bio);
